import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import Loading from "./loader";
import { ArrowLeftOutlined } from "@ant-design/icons";
import StateWarning from './StateWarning';

class VoteStream extends Component {
    state = {
        streamUrl: null,
        loading: true,
    };

    async componentDidMount() {
        const { match } = this.props;
        const meetingId = match.params.meetingId;

        const globalAccessToken = localStorage.getItem(`globalAccessToken`);
        const path = window.location.hash.split('/');
        const firstParam = path[2];

        if (firstParam) {
            if (!globalAccessToken || !globalAccessToken.startsWith(`${firstParam}`)) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
                return;
            }
        } else {
            localStorage.removeItem(`globalAccessToken`);
        }

        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        try {
            const response = await fetch(`${API_ADDRESS}get_stream/${meetingId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            const data = await response.json();
            this.setState({ streamUrl: data.meeting_url, loading: false });
        } catch (e) {
            console.error(e);
        }
    }

    handleBackClick = () => {
        window.history.back();
    };

    render() {
        const { streamUrl, loading } = this.state;

        if (loading) {
            return <div><Loading /></div>;
        }

        return (
            <>
                <div className="page-container">
                    <div className="header-container">
                        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
                            <div className="back-button-wrapper" onClick={this.handleBackClick}>
                                <ArrowLeftOutlined
                                    style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                                />
                            </div>
                            <h1>Трансляция собрания</h1>
                        </div>
                    </div>
                    {streamUrl ? (
                        <>
                            <div className="video-container">
                                <video
                                    src={streamUrl}
                                    controls
                                    autoPlay
                                    className="stream-player"
                                />
                            </div>
                        </>
                    ) : (
                        <StateWarning message="Прямая трансляция на данный момент отсутствует"/>
                    )}
                </div>
            </>
        );
    }
}

export default withRouter(VoteStream);